export default __webpack_public_path__ + "static/media/clickfunnels_logo.82b75895.png";